import Matter from 'matter-js'
import { FruitType } from './FruitTypes'
import { Physics } from './Physics'

let fruitIdCounter = 0

export class Fruit {
  id: number
  type: FruitType
  body: Matter.Body
  isDropped: boolean = false
  markedForRemoval: boolean = false

  constructor(type: FruitType, x: number, y: number, physics: Physics, isStatic: boolean = true) {
    this.id = fruitIdCounter++
    this.type = type
    this.body = physics.createCircle(x, y, type.radius, {
      isStatic,
      label: `fruit-${this.id}`,
      render: {
        fillStyle: type.color
      }
    })

    // Store reference to fruit on the body for collision detection
    ;(this.body as Matter.Body & { fruit?: Fruit }).fruit = this

    physics.addBody(this.body)
  }

  get x(): number {
    return this.body.position.x
  }

  get y(): number {
    return this.body.position.y
  }

  get radius(): number {
    return this.type.radius
  }

  drop(physics: Physics): void {
    if (this.isDropped) return
    this.isDropped = true
    physics.setBodyStatic(this.body, false)
  }

  remove(physics: Physics): void {
    this.markedForRemoval = true
    physics.removeBody(this.body)
  }

  isAboveLine(lineY: number): boolean {
    // Check if any part of the fruit is above the line
    return this.y - this.radius < lineY
  }

  hasSettled(): boolean {
    // Consider settled if velocity is very low
    const speed = Math.sqrt(
      this.body.velocity.x ** 2 + this.body.velocity.y ** 2
    )
    return speed < 0.5 && this.isDropped
  }
}

export function getFruitFromBody(body: Matter.Body): Fruit | null {
  return (body as Matter.Body & { fruit?: Fruit }).fruit || null
}
